import React from "react";
import { AccountLayout } from './accountLayout';
import { MainLayout } from './mainLayout';
import { Alert } from './alert';
import { Loading } from './loading';
import { useLocation } from 'react-router-dom';

const MenuNavContainer = (props) => {
    const { pathname } = useLocation();
    const accountRoutes = ["/login", "/404"];

    const isAccountRoute = accountRoutes.some(x => x == pathname?.toLowerCase());

    return (<>
        {isAccountRoute && <AccountLayout>{props.children}</AccountLayout>}
        {!isAccountRoute && <MainLayout>{props.children}</MainLayout>}

        <Alert />
        <Loading />
    </>);
};

export default MenuNavContainer;